import styled from 'styled-components';

export const SectionHeadingCenter = styled.div`
  position: relative;
  text-align: center;

  h2 {
    color: #4a4a4a;

    @media (max-width: 767.98px) {
      font-size: 20px;
      line-height: 30px;
      margin-bottom: 1rem;
    }
  }

  &.tabsection {
    h2 {
      margin-bottom: 1rem;
    }
    @media (max-width: 767.98px) {
      padding: 0 0 1rem;
    }
  }
`;

export const Heading = styled.p`
  font-size: 16px;
  letter-spacing: ${({ dir }) => (dir === 'rtl' ? '' : '1.29px')};
  line-height: 20px;
  color: #4a4a4a;
  margin-bottom: 1.5rem;

  &.fs_sub {
    @media (max-width: 768px) {
      font-size: 13px;
      letter-spacing: normal;
      line-height: 20px;
      color: #898989;
      margin: 0;
    }
  }
`;
